import { Inbox, type LucideIcon } from 'lucide-react';
import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
} from '@herit-fe/heritage-ui';

export interface EmptyStateProps {
  /** 제목 — 비어있는 이유. */
  title: string;
  /** 보조 설명(선택). */
  description?: string;
  /** 빈 상태 아이콘(기본 Inbox) — 도메인에 어울리는 아이콘으로 교체 가능(발전소·이벤트·계정 등). */
  icon?: LucideIcon;
}

/**
 * 국소 빈 상태 표준 UI — 조회는 성공했으나 표시할 데이터가 0건일 때 데이터 영역을 채운다(heritage `Empty`
 * 합성). 에러(`ErrorState`)와 구분: 빈 상태는 정상 결과다. 데이터 소유자가 `length === 0` 분기에서 렌더.
 * 테두리(카드 chrome)는 자체로 두지 않는다 — 컨테이너(`DataStateRegion`/카드)가 제공해 이중 테두리 회피.
 */
export function EmptyState({ title, description, icon: Icon = Inbox }: EmptyStateProps) {
  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon />
        </EmptyMedia>
        <EmptyTitle className="text-base">{title}</EmptyTitle>
        {description ? <EmptyDescription>{description}</EmptyDescription> : null}
      </EmptyHeader>
    </Empty>
  );
}
